/**
 * Seconds of race render time since the last frame, for easing that must keep up at any frame rate.
 * The loop caps its dt at 0.1 s, so on a slow frame rate (about 1 fps in headless replays) easing on
 * dt falls far behind the race. A jump in render time counts as at most 1 s; the first frame uses dt.
 */
export function renderStep(lastT: number, t: number, dt: number): number {
  return Number.isNaN(lastT) ? dt : Math.min(1, Math.max(0, (t - lastT) / 1000));
}
